import { css, cx, etiColors } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { constants, traveler } from '@eti/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const cellStyles = css`
  align-items: baseline;
  display: table-cell;
  font-size: 0.75rem;

  @media (max-width: 47.9375em) {
    display: block;
    margin-left: 36px;

    html[dir='rtl'] & {
      margin-left: 0;
      margin-right: 36px;
    }
  }

  @media (min-width: 48em) {
    font-size: 0.875rem;
  }

  & div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    html[dir='rtl'] & {
      text-align: right;
    }
  }

  & span {
    color: ${etiColors.grayScale[9]};
    display: block;
    font-size: 0.625rem;

    @media (min-width: 48em) {
      font-size: 0.75rem;
    }
  }
`;
const TravelerCell = _ref => {
  let {
    ageType,
    name
  } = _ref;
  const {
    t
  } = useTranslation();
  const adultLabel = t('Adult');
  const childLabel = t('Child');
  const infantLabel = t('Infant');
  return /*#__PURE__*/_jsx("td", {
    className: cx(cellStyles, MOUSE_FLOW_CLASS_NAMES),
    children: /*#__PURE__*/_jsxs("div", {
      children: [name, /*#__PURE__*/_jsx("span", {
        children: traveler.resolveLabelFromType(ageType, adultLabel, childLabel, infantLabel)
      })]
    })
  });
};
export default TravelerCell;
//# sourceMappingURL=SummaryTravelerCell.js.map